var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"absolute","left":"-1000px","width":"0","height":"0"},attrs:{"id":_vm.tempId}},[_c('share-btn',{ref:"shareBtn",attrs:{"config":_vm.conf,"shareData":_vm.shareData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }